"use client"

import { useState, useEffect } from "react"
import AnimatedLogo from "./Animation"
import "./Animation.css"

const AnimatedIntro = ({ onComplete }) => {
    const [showIntro, setShowIntro] = useState(true)

    useEffect(() => {
        const hasSeenIntro = sessionStorage.getItem("hasSeenIntro")
        if (hasSeenIntro) {
            setShowIntro(false)
            onComplete()
        } else {
            const timer = setTimeout(() => {
                setShowIntro(false)
                sessionStorage.setItem("hasSeenIntro", "true")
                onComplete()
            }, 4000) // Adjust this time to match your animation duration

            return () => clearTimeout(timer)
        }
    }, [onComplete])

    if (!showIntro) return null

    return <AnimatedLogo />
}

export default AnimatedIntro

